// extracted by mini-css-extract-plugin
export var backupIcon = "_sf-1";
export var image = "_sf-0";